import {
    BreachEvent,
    createRegisterableComponent,
    DataLayerEventName,
} from '@news-mono/web-common'
import { TheWestSections } from '@west-australian-newspapers/publication-types'
import React, { useEffect } from 'react'
import { MessageBanner } from '../../banners/MessageBanner/MessageBanner'
import { useFeatureForSection } from '../../feature-toggling'
import { packageOfferDetails } from './common'
import { BreachWallContent } from './components/BreachNotificationWrapper/BreachNotification/BreachWallContent/BreachWallContent'
import {
    StyledMessage,
    StyledTerms,
    StyledTitle,
} from './components/BreachNotificationWrapper/BreachNotification/BreachWallContent/BreachWallContent.styled'
import { WestRewardsMessage } from './components/BreachNotificationWrapper/shared-components/WestRewardsMessage/WestRewardsMessage'

export interface BreachScreenRegistrationProps {
    bannerMessage?: string
    breachCreativeName: string
    breachDeal: string
    title: string
    message?: string
    terms: string
}

export const BreachScreenRegistration = createRegisterableComponent(
    'breachscreen',
    (props: BreachScreenRegistrationProps, services) => {
        const is50percentOffDeal =
            props.breachDeal === 'COVIDDIG' || props.breachDeal === 'GOVAN50'

        const is30percentOffDeal =
            props.breachDeal === 'BIKEDI30' || props.breachDeal === 'SCHOOL30'

        const subscriptionPackages = packageOfferDetails(
            props.breachDeal === 'epaper-regional' ? 'digital-only' : 'default',
        )

        const eventPayload: BreachEvent['payload'] = {
            paywallType: 'freemium',
            leadDepth: 0,
            creative: 'registration wall - launch',
            breachScreenType: 'Registration - Inline',
            popupMethod: 'auto',
            deal: '',
            pricepoint: [],
        }

        const isNewDesign2022 = useFeatureForSection({
            feature: 'tp-subscription-new-breach-package-background',
            sections: TheWestSections.default,
        })

        // Fire the available event
        useEffect(() => {
            services.onEvent({
                type: DataLayerEventName.breachScreenAvailable,
                originator: 'breachscreen',
                payload: eventPayload,
            })
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [])

        return (
            <div data-testid="BreachScreen">
                {props.bannerMessage && (
                    <MessageBanner
                        icon="subscriber"
                        connector="solid-arrow"
                        onEvent={services.onEvent}
                    >
                        <p>{props.bannerMessage}</p>
                    </MessageBanner>
                )}

                <BreachWallContent
                    breachCreativeName={props.breachCreativeName}
                    breachDeal={props.breachDeal}
                    onEvent={services.onEvent}
                    title={() => {
                        if (is50percentOffDeal) {
                            return (
                                <React.Fragment>
                                    <StyledTitle>Limited Offer</StyledTitle>
                                    <StyledMessage>
                                        <p>Save over 50% for 8 weeks*</p>
                                    </StyledMessage>
                                </React.Fragment>
                            )
                        }
                        if (is30percentOffDeal) {
                            return (
                                <React.Fragment>
                                    <StyledTitle>
                                        Limited Time Offer
                                    </StyledTitle>
                                    <StyledMessage>
                                        <p>
                                            Subscribe now to save 30%* and enjoy
                                            unlimited access to investigative
                                            video series, breaking news, sport,
                                            business and lifestyle direct to
                                            your device
                                        </p>
                                    </StyledMessage>
                                </React.Fragment>
                            )
                        }
                        return (
                            <React.Fragment>
                                <StyledTitle>{props.title}</StyledTitle>
                                {props.message && (
                                    <StyledMessage>
                                        <p>{props.message}</p>
                                    </StyledMessage>
                                )}
                            </React.Fragment>
                        )
                    }}
                    terms={() => {
                        if (is50percentOffDeal || is30percentOffDeal) {
                            return (
                                <StyledTerms>
                                    *Valid for new subscribers only.
                                    {` ${breachDealTerms(props.breachDeal)}`}
                                    <br />
                                    T&Cs apply
                                </StyledTerms>
                            )
                        }

                        return null
                    }}
                    mediaBanner={() => {
                        return null
                    }}
                    subscriptionPackages={subscriptionPackages}
                />
                {isNewDesign2022 && <WestRewardsMessage />}
            </div>
        )
    },
)

function breachDealTerms(deal: string) {
    switch (deal) {
        case 'SCHOOL30':
            return 'Offer ends 23 November 2021.'
        case 'BIKEDI30':
            return 'Offer ends 21 November 2021.'
        case 'GOVAN50':
            return 'Offer ends 20 February 2021.'
        case 'BRE1DISC':
            return 'Offer ends 2 May 2021.'
        default:
            return ''
    }
}
